import type {} from '@tanstack/react-query';
import { _listInProject } from './ListInProject';

export const useMember = {
  ListInProject: _listInProject,
};
